module.exports = __webpack_public_path__ + "img/icon (7).1c537f25.png";